// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-range.time-slider {
  --bar-background: #1b171b;
  --bar-background-active: #1b171b;
  --bar-height: 3px;
  --knob-background: #ffffff;
  --knob-box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
ion-range.time-slider.adjusted-range {
  --bar-background: #1b171b;
  --bar-background-active: #1ecb40;
  --knob-background: #ffffff;
}
ion-range.time-slider.selected-range {
  --bar-background: #1b171b;
  --bar-background-active: #1ecb40;
  --knob-background: #ffffff;
}

.error-container {
  background: #ed143d;
  color: white;
  padding: 10px;
  font-size: 14px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.container {
  margin: 5px;
  border-radius: 8px;
  padding: 0 10px 50px 10px;
}
.container ion-input {
  margin-bottom: 10px;
}

.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: #efefef;
  border-radius: 8px;
}

.time-period-container {
  margin-bottom: 15px;
  border-radius: 8px;
  padding: 5px;
  min-height: 75px;
}
.time-period-container .time-period {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: #efefef;
  padding: 10px;
  border-radius: 8px;
}
.time-period-container .time-period:not(:last-child) {
  margin-bottom: 15px;
}
.time-period-container .select-button {
  min-height: unset;
  --background: black;
  --padding-bottom: 8px;
  --padding-top: 8px;
  margin: 0;
}
.time-period-container ion-icon {
  color: #ed143d;
  font-size: 20px;
}
.time-period-container ion-datetime-button {
  border-radius: 8px;
  font-weight: 600;
}
.time-period-container ion-datetime-button::part(native) {
  background-color: white;
  padding-block: 5px;
  font-weight: 600;
}
.time-period-container ion-range ion-label {
  font-size: 14px;
  font-weight: 600;
}

ion-toggle {
  font-weight: 600;
  display: block;
  margin: 0 auto;
  --track-background-checked: #ed143d;
  width: 100%;
}

.meeting-day-picker {
  display: flex;
  align-items: center;
}
.meeting-day-picker span {
  font-weight: 600;
  flex: 0.5;
  color: #888;
  margin: 0;
  padding: 0;
}
.meeting-day-picker ion-chip {
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  font-weight: 700;
  letter-spacing: 1.2px;
  flex: 1;
}

ion-select {
  transform: translateY(-4px);
}
ion-select ion-icon {
  color: #ed143d;
  font-size: 20px;
  margin-right: 10px;
}

ion-popover.datetime-popover::part(content) {
  --width: 350px;
  --max-width: 90%;
  --height: auto;
}

ion-datetime {
  --ion-color-primary: #ed143d;
  box-shadow: none;
  padding-top: 8px;
}

ion-datetime::part(calendar-day):focus {
  box-shadow: none;
}

ion-datetime::part(time-button) {
  background: #fff9f9;
  border: 2px solid #ed143d;
  font-weight: 600;
}

ion-datetime::part(month-year-button) {
  color: #ed143d;
  padding-block: 0;
  transform: translateY(-8px);
}

ion-select::part(label) {
  color: #888;
  font-size: 17px;
}

ion-select::part(container) {
  font-size: 15px;
}

ion-select::part(icon) {
  color: #ed143d;
  transform: translateY(10px);
}`, "",{"version":3,"sources":["webpack://./src/app/avaliable-time-booking/avaliable-time-booking.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,gCAAA;EACA,iBAAA;EACA,0BAAA;EACA,wDAAA;AACF;AACE;EACE,yBAAA;EACA,gCAAA;EACA,0BAAA;AACJ;AAEE;EACE,yBAAA;EACA,gCAAA;EACA,0BAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AADF;;AAIA;EAEE,WAAA;EACA,kBAAA;EACA,yBAAA;AAFF;AAGE;EACE,mBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,mBAAA;EAEA,kBAAA;EACA,YAAA;EAEA,gBAAA;AALF;AAME;EACE,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAJJ;AAKI;EACE,mBAAA;AAHN;AAME;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;AAJJ;AAME;EACE,cAAA;EACA,eAAA;AAJJ;AAOE;EACE,kBAAA;EACA,gBAAA;AALJ;AAOI;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;AALN;AASI;EACE,eAAA;EACA,gBAAA;AAPN;;AAYA;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;AATF;AAUE;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AARJ;AAUE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,OAAA;AARJ;;AAYA;EACE,2BAAA;AATF;AAUE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AARJ;;AAYA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;AATF;;AAYA;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;AATF;;AAYA;EACE,WAAA;EACA,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,cAAA;EACA,2BAAA;AATF","sourcesContent":["ion-range.time-slider {\n  --bar-background: #1b171b;\n  --bar-background-active: #1b171b;\n  --bar-height: 3px;\n  --knob-background: #ffffff;\n  --knob-box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n\n  &.adjusted-range {\n    --bar-background: #1b171b;\n    --bar-background-active: #1ecb40;\n    --knob-background: #ffffff;\n  }\n\n  &.selected-range {\n    --bar-background: #1b171b;\n    --bar-background-active: #1ecb40;\n    --knob-background: #ffffff;\n  }\n}\n\n.error-container {\n  background: #ed143d;\n  color: white;\n  padding: 10px;\n  font-size: 14px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.container {\n  // height:100%;\n  margin: 5px;\n  border-radius: 8px;\n  padding: 0 10px 50px 10px;\n  ion-input {\n    margin-bottom: 10px;\n  }\n}\n\n.spinner-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  // background: rgba(0, 0, 0, 0.1);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  background: #efefef;\n  border-radius: 8px;\n}\n\n.time-period-container {\n  margin-bottom: 15px;\n  // box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 5px;\n  // background:#efefef;\n  min-height: 75px;\n  .time-period {\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    background: #efefef;\n    padding: 10px;\n    border-radius: 8px;\n    &:not(:last-child) {\n      margin-bottom: 15px;\n    }\n  }\n  .select-button {\n    min-height: unset;\n    --background: black;\n    --padding-bottom: 8px;\n    --padding-top: 8px;\n    margin: 0;\n  }\n  ion-icon {\n    color: #ed143d;\n    font-size: 20px;\n  }\n\n  ion-datetime-button {\n    border-radius: 8px;\n    font-weight: 600;\n\n    &::part(native) {\n      background-color: white;\n      padding-block: 5px;\n      font-weight: 600;\n    }\n  }\n  ion-range {\n    ion-label {\n      font-size: 14px;\n      font-weight: 600;\n    }\n  }\n}\n\nion-toggle {\n  font-weight: 600;\n  display: block;\n  margin: 0 auto;\n  --track-background-checked: #ed143d;\n  width: 100%;\n}\n\n.meeting-day-picker {\n  display: flex;\n  align-items: center;\n  span {\n    font-weight: 600;\n    flex: 0.5;\n    color: #888;\n    margin: 0;\n    padding: 0;\n  }\n  ion-chip {\n    display: flex;\n    justify-content: space-between;\n    border-radius: 6px;\n    font-weight: 700;\n    letter-spacing: 1.2px;\n    flex: 1;\n  }\n}\n\nion-select {\n  transform: translateY(-4px);\n  ion-icon {\n    color: #ed143d;\n    font-size: 20px;\n    margin-right: 10px;\n  }\n}\n\nion-popover.datetime-popover::part(content) {\n  --width: 350px;\n  --max-width: 90%;\n  --height: auto;\n}\n\nion-datetime {\n  --ion-color-primary: #ed143d;\n  box-shadow: none;\n  padding-top: 8px;\n}\n\nion-datetime::part(calendar-day):focus {\n  box-shadow: none;\n}\n\nion-datetime::part(time-button) {\n  background: #fff9f9;\n  border: 2px solid #ed143d;\n  font-weight: 600;\n}\n\nion-datetime::part(month-year-button) {\n  color: #ed143d;\n  padding-block: 0;\n  transform: translateY(-8px);\n}\n\nion-select::part(label) {\n  color: #888;\n  font-size: 17px;\n}\n\nion-select::part(container) {\n  font-size: 15px;\n}\n\nion-select::part(icon) {\n  color: #ed143d;\n  transform: translateY(10px);\n}\n\n// ion-footer {\n//     box-shadow: 1px -4px 6px rgba(0, 0, 0, 0.25);\n//     div {\n//       padding: 10px 20px;\n//       background-color: #efefef;\n//       ion-button {\n//         min-height: unset;\n//         --background:#ed143d;\n//         margin: 0;\n//        &::part(native) {\n//           border-radius: 6px;\n//        }\n//       }\n//     }\n//   }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
